import { createWebHistory, createRouter } from 'vue-router'

import VideoChatPage from '../pages/VideoChat/VideoChatPage.vue'

const routes = [
  { path: '/incident/:id', component: VideoChatPage },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
